import jsstacktrace from "refractor/jsstacktrace";
export default jsstacktrace;